import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import MainLayout from "layouts/MainLayout";
import { useParams } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import { useTranslation } from "react-i18next";
import { sidebarMenuStore } from "features/SidebarMenu/SidebarMenuStore";
import EPDSearchContent from "features/EPDSearchModal/features/EPDSearchContent";
import { epdSearchStore } from "features/EPDSearchModal/EPDSearchStore";

const OrganisationEPDList = () => {
  const { organisation_id } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    epdSearchStore.setIsOrganisationalSearch(true);

    sidebarMenuStore.setOrganisationID(organisation_id);
    buildingStore.setCurrentBuilding(undefined);
    buildingStore.setBuildingID(undefined);
    return () => {
      epdSearchStore.setIsOrganisationalSearch(false);
    };
  }, [organisation_id]);

  if (!epdSearchStore.isOrganisationalSearch) {
    return null;
  }

  return (
    <MainLayout
      headerTitle={t("dashboard.EPDList")}
      className="overflow-y-auto bg-white p-6 !max-h-[calc(100vh-64px)]"
    >
      <EPDSearchContent
        open={true}
        close={() => {}}
        datasetIndex={0}
        rowIndex={0}
      />
    </MainLayout>
  );
};

export default observer(OrganisationEPDList);
